let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1kDVI")).then(() => parcelRequire('20hKC'));